export default __webpack_public_path__ + "static/media/header-auth-icon.f08319ca.svg";